import React, { useState } from 'react';

import { Divider, MenuList as MaterialMenuList, Paper, styled } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Icon from '../Icon/Icon';
import Input from '../Input/Input';

export interface IMenuList {
  children?: React.ReactNode;
  elevation?: number;
  showSelectionCheckItem?: boolean;
  withSearch?: boolean;
  width?: number;
  searchPlaceholder?: string;
}
const ELEVATION = 4;

const MenuListPaper = styled(Paper, { name: 'ContextMenuPaper' })(() => ({
  display: 'inline-block'
}));

export const MenuList = ({
  children,
  elevation,
  width,
  showSelectionCheckItem = true,
  withSearch,
  searchPlaceholder
}: IMenuList): JSX.Element => {
  const [searchValue, setSearchValue] = useState<string>('');

  const filteredChildren = React.Children.toArray(children)
    .filter(child => {
      if ((!withSearch && !searchValue) || !React.isValidElement(child)) {
        return true;
      }

      return child.props.text.toLowerCase().includes(searchValue.toLowerCase());
    })
    .map(child => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { showSelectionCheckItem });
      }

      return child;
    });

  return (
    <MenuListPaper
      elevation={elevation ?? ELEVATION}
      sx={theme => ({
        width: width ?? theme.spacing(withSearch ? 32 : 22),
        backgroundImage: 'none',
        backgroundColor: theme.palette.grey[500],
        maxHeight: '60vmax',
        overflowY: 'scroll'
      })}
    >
      {withSearch ? (
        <>
          <Input
            placeholder={searchPlaceholder}
            value={searchValue}
            autoComplete={'off'}
            type="text"
            onChange={event => {
              setSearchValue(event?.target?.value);
            }}
            startAdornment={
              <InputAdornment position="start">
                <Icon name="search" width={18} height={18} />
              </InputAdornment>
            }
            sx={theme => {
              const { fontSize, lineHeight } = theme.typography.buttonMd;

              return {
                margin: theme.spacing(2),

                '& .MuiInputBase-root': {
                  fontSize,
                  lineHeight,
                  fontWeight: theme.typography.fontWeightLight
                }
              };
            }}
          />
          <Divider sx={theme => ({ margin: theme.spacing(0, 2), borderColor: theme.palette.transparent.white[12] })} />
        </>
      ) : null}

      <MaterialMenuList
        sx={theme => ({
          padding: theme.spacing(withSearch ? 0.5 : 2, 2, 2)
        })}
      >
        {filteredChildren}
      </MaterialMenuList>
    </MenuListPaper>
  );
};

export default MenuList;
